import { createAction, createReducer } from "redux-act";
import { api_base_url } from "../../constants";
import { getAppLocale } from "../../utils/app-locale";
import { API_INSTANCE } from "../../utils/service-http";

/* Check product availability information retrivial */

const DEFAULT_STATE_PRODUCTS_AVAILABILITY = {
  availabilityStatus: {},
  isLoading: false,
  error: null,
};

export const getProductsAvailabilityStarted = createAction(
  "GET_PRODUCTS_AVAILABILITY_STARTED"
);
export const getProductsAvailabilitySucces = createAction(
  "GET_PRODUCTS_AVAILABILITY_SUCCES"
);
export const getProductsAvailabilityFailed = createAction(
  "GET_PRODUCTS_AVAILABILITY_FAILED"
);

export const getProductsAvailabilityReducer = createReducer(function (on, off) {
  on(getProductsAvailabilityStarted, (state, payload) => {
    return {
      ...state,
      availabilityStatus: {},
      isLoading: true,
      error: null,
    };
  });
  on(getProductsAvailabilitySucces, (state, payload) => {
    return {
      ...state,
      availabilityStatus: payload,
      isLoading: false,
      error: null,
    };
  });
  on(getProductsAvailabilityFailed, (state, payload) => {
    return {
      ...state,
      availabilityStatus: {},
      isLoading: false,
      error: null,
    };
  });
}, DEFAULT_STATE_PRODUCTS_AVAILABILITY);

export const getProductsAvailability = (refIds) => {
  return async (dispatch) => {
    dispatch(getProductsAvailabilityStarted());
    return API_INSTANCE.post(
      `${api_base_url}/products-availability?locale=${getAppLocale()}`,
      { refIds: refIds }
    )
      .then((success) => {
        const payload = success?.data?.payload || {};
        const availability = payload || {};
        dispatch(getProductsAvailabilitySucces(availability));

        return availability;
      })
      .catch((error) => {
        dispatch(getProductsAvailabilityFailed());
        throw error;
      });
  };
};
